import { useState } from "react";
import { Feeling, LiveVideo, Photo } from "../../svg";
import "./style.css";
import FeelingActivitySelector from "../createPostPopup/FeelingActivitySelector";
import CreateLifeUpdateModal from "../createLifeUpdateModal";
import { createPost } from "../../functions/post";

export default function CreatePost({ user, setVisible, profile, onLiveStreamClick, dispatch, getAllPosts, openWithPicker }) {
  const [showQuickFeeling, setShowQuickFeeling] = useState(false);
  const [selectedFeeling, setSelectedFeeling] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [posting, setPosting] = useState(false);
  const [showLifeUpdateModal, setShowLifeUpdateModal] = useState(false);

  const toTitle = (id) => id.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  const handleQuickPost = async () => {
    if (!selectedFeeling && !selectedActivity) return;
    try {
      setPosting(true);
      const parts = [];
      if (selectedFeeling) parts.push(`is feeling ${toTitle(selectedFeeling)}`);
      if (selectedActivity) parts.push(`is ${toTitle(selectedActivity)}`);
      const text = parts.join(" and ");
      const res = await createPost(
        null,
        null,
        text || " ",
        null,
        user.id,
        user.token,
        selectedFeeling,
        selectedActivity,
        null,
        []
      );
      setPosting(false);
      if (res.status === "ok") {
        dispatch && dispatch({ type: "ADD_POST", payload: res.data });
        // Refresh feed if available
        if (typeof getAllPosts === "function") {
          getAllPosts();
        }
        // reset
        setSelectedFeeling(null);
        setSelectedActivity(null);
        setShowQuickFeeling(false);
      } else {
        // Fallback: open full composer with error or selection retained
        setShowQuickFeeling(false);
        setVisible && setVisible(true);
      }
    } catch (e) {
      setPosting(false);
      setShowQuickFeeling(false);
      setVisible && setVisible(true);
    }
  };

  return (
    <div className="createPost">
      <div className="createPost_header">
        <img src={user?.picture} alt={user?.first_name} />
        <div 
          className="open_post"
          onClick={() => setVisible && setVisible(true)}
        >
          What's on your mind, {user?.first_name}?
        </div>
        <div className="createPost_body">
        <div 
          className="createPost_icon hover1"
          onClick={onLiveStreamClick}
        >
          <LiveVideo color="#f3425f" />
          {/* VideoLive  */}
        </div>     
        <div
          className="createPost_icon hover1"
          onClick={() => {
            if (typeof openWithPicker === "function") {
              openWithPicker();
            } else {
              setVisible(true);
            }
          }}
        >
          <Photo color="#4bbf67" />
          {/* Photo/Video */}
        </div>
        {profile ? (
          <div 
            className="createPost_icon hover1"
            onClick={() => setShowLifeUpdateModal(true)}
          >
            <i className="lifeEvent_icon"></i>
            Life Event
          </div>
        ) : (
          <div
            className="createPost_icon hover1"
            onClick={() => setShowQuickFeeling(true)}
          >
            <Feeling color="#f7b928" />
            {/* Feeling/Activity */}
          </div>
        )}
        </div>
      </div>
      {showQuickFeeling && (
        <FeelingActivitySelector
          selectedFeeling={selectedFeeling}
          selectedActivity={selectedActivity}
          onFeelingSelect={setSelectedFeeling}
          onActivitySelect={setSelectedActivity}
          onClose={() => setShowQuickFeeling(false)}
          onSubmit={handleQuickPost}
          submitLabel={posting ? "Sending..." : "Send"}
        />
      )}
      {showLifeUpdateModal && (
        <CreateLifeUpdateModal
          user={user}
          dispatch={dispatch}
          getAllPosts={getAllPosts}
          onClose={() => setShowLifeUpdateModal(false)}
        />
      )}
    </div>
  );
}
